import { Typography } from "@lyfegen-platform/react-common";
import { Box, useTheme } from "@material-ui/core";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import useStyles from "../containers/data/forms/forms-styles";
import { getFormDatesByCases } from "../hooks/useSiblingFormDates";
import { FlexContext } from "../models/flexible/flex-context";
import { FlexFieldController } from "../models/flexible/flex-field-controller";
import { FlexSectionController } from "../models/flexible/flex-section-controller";
import { FlexSectionSchema } from "../models/flexible/flex-section-schema";
import { Maybe } from "../models/generated/graphql";

function RenderBanner(props: { context: FlexContext }) {
	const styles = useStyles();
	const { t } = useTranslation();
	const { palette } = useTheme();
	const dates = getFormDatesByCases(props.context.cases, props.context.flexEntity?.createdOn);

	return (
		<Box className={styles.subHeader} mb={2} p={2} pl={5} style={{ backgroundColor: palette.inputTableDivider.main }}>
			{dates.maxPrescriptionDate ? (
				<Typography type="fieldText">
					{`${t("please-list-all-prescriptions")} - ${format(
						new Date(dates.maxCBAssessmentDate ? dates.maxCBAssessmentDate : dates.responseAssessmentDate || ""),
						"dd LLL yyyy"
					)}. ${t("latest-previous-prescription")} - ${format(dates.maxPrescriptionDate, "dd LLL yyyy")}. `}
					{t("bellow-paid-by-insurance")}
				</Typography>
			) : (
				<Typography type="fieldText">{t("add-first-cb")}</Typography>
			)}
		</Box>
	);
}

export class PrescriptionSectionController implements FlexSectionController {
	context: FlexContext = {} as any;

	constructor(
		readonly schema: FlexSectionSchema,
		readonly path: string,
		readonly fieldControllers: Array<FlexFieldController>,
		readonly sectionControllers: Array<FlexSectionController>
	) {}

	renderAfterHeader(): Maybe<React.ReactElement> {
		return this.context.isEditable ? <RenderBanner context={this.context} /> : null;
	}
}
